export const qucikLoanPLV1 = ["postalCode", "state", "city"];

export const detailedLoanPLV1 = ["address", "postalCode", "state", "city"];
